// extracted by extract-css-chunks-webpack-plugin
module.exports = {"order-status-map":"OrderStatusMap-95ae6a6b8f9e5f12","map":"OrderStatusMap-ae70f2ea33935c86"};